module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"statusOk":"OK","statusNotOk":"No answer","loopNegative":"Open","loopPositive":"OK"},"de":{"statusOk":"OK","statusNotOk":"Keine Antwort","loopNegative":"Offen","loopPositive":"OK"},"fr":{"statusOk":"OK","statusNotOk":"Aucune réponse","loopNegative":"Ouvert","loopPositive":"OK"},"it":{"statusOk":"OK","statusNotOk":"Nessuna risposta","loopNegative":"Aperto","loopPositive":"OK"}}')
  delete Component.options._Ctor
}
